<template>
    <div class="d-flex w-100 align-items-start">
        <select :id="id" :name="name" class="form-select" :class="classSelect" style="width: 100%" multiple>
            <slot></slot>
        </select>

        <button class="btn btn-secondary ms-4"
                title="Añadir todos"
                @click="addAll"
                v-if="!!btnAddAll">
            <span class="uq-icon bi-plus"></span>
        </button>
    </div>
</template>

<script>

import 'select2/dist/css/select2.css';
import 'select2/dist/js/select2';

export default {
    name: "VMultiSelectJQ",
    props: ['id', 'name', 'options', 'value', 'classSelect', 'parentId', 'placeholder', 'btnAddAll'],
    mounted: function () {
        window.$ = window.jQuery = require('jquery');

        let vm = this;

        $('#' + this.id)
            .select2({
                data: this.options,
                dropdownParent: $('#' + this.parentId),
                placeholder: this.placeholder,
                allowClear: true,
                width: 'resolve'
            })
            .val(this.value)
            .trigger('change')
            .on('change', function () {
                vm.$emit('update:value', ($('#' + this.id).val()));
                vm.$emit('change', ($('#' + this.id).val()))
            });
    },
    watch: {
        value: function (value) {
            $('#' + this.id).val(value);
        },
        options: function (options) {
            // update options
            $('#' + this.id).select2({data: options})
        }
    },
    unmounted: function () {
        $('#' + this.id).off().select2('destroy');
    },
    methods: {
        addAll() {
            let nameStatuses = [];

            for (let key in this.options) {
                let status = this.options[key].id;

                nameStatuses.push(status);
            }

            $('#' + this.id).val(nameStatuses).trigger('change');
        },
        removeAll() {
            $('#' + this.id).val(null).trigger('change');
        },
        updateSelect(newValues) {
            $('#' + this.id).val(newValues).trigger('change');
        }
    }
}
</script>
